import { useMemo } from 'react';
import { Configuration, OrdersApi } from '@/api';
import { SupplierStoreOrderVarianceFilters } from '@/api/OrdersApi';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import { useQuery } from '@tanstack/react-query';

const DEFAULT_LIMIT = 5;

const DEFAULT_FILTERS: SupplierStoreOrderVarianceFilters = {
  varianceThresholdPercent: '50',
  minimumOverdueDays: '2',
};

const useSupplierStoreOrderVariancesQuery = (
  filters: SupplierStoreOrderVarianceFilters = DEFAULT_FILTERS,
  limit = DEFAULT_LIMIT,
  enabled = true,
) => {
  const auth = useAuth();
  const ordersApi = useMemo(() => new OrdersApi(new Configuration(auth)), [auth]);
  const effectiveFilters = { ...DEFAULT_FILTERS, ...filters };

  const query = useQuery({
    queryKey: ['supplier-store-order-variances', effectiveFilters, limit],
    enabled,
    queryFn: () => ordersApi.listSupplierStoreOrderVariances(effectiveFilters, 0, limit),
  });

  return {
    variances: query.data?.items ?? [],
    totalCount: query.data?.totalCount ?? query.data?.estimatedTotalCount ?? 0,
    estimatedTotalCount: query.data?.estimatedTotalCount ?? 0,
    isEstimatedTotalCount: query.data?.totalCount === undefined && query.data !== undefined,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error,
  };
};

export default useSupplierStoreOrderVariancesQuery;
